import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const CalendarStore = {
  state: {
    calendars: [],
    events: []
  },
  getters,
  mutations,
  actions
}

export default CalendarStore
